import { useGetApplicazioniAnagraficaApplicazione } from '@framework/api-client/api/users/applicazioni-controller/applicazioni-controller.ts';
import { LoaderSpin } from '@framework/ui/components/loader/LoaderSpin.tsx';
import { useDispatch } from 'react-redux';
import { ClientConfigActions } from './ClientConfigSlice.tsx';

export interface IClientConfigLoaderProps {
  children: React.ReactNode;
}

/**
 * Carica la configurazione del client e la salva nello store.
 */
export function ClientConfigLoader(props: IClientConfigLoaderProps) {
  const dispatch = useDispatch();
  const { data, isLoading } = useGetApplicazioniAnagraficaApplicazione({
    query: {
      enabled: true,
      keepPreviousData: true,
      onSuccess: clientConfig => {
        dispatch(ClientConfigActions.setClientConfig(clientConfig));
      },
    },
  });

  if (isLoading) {
    return <LoaderSpin full />;
  }

  return props.children;
}
